import React, { forwardRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
const StyledChildrenWrapper = styled.div `
  position: absolute;
`;
const getChildrenWrapperStyles = (contextualElementRef) => {
    if (contextualElementRef && contextualElementRef.current) {
        const { top, left, width, height } = contextualElementRef.current.getBoundingClientRect();
        return {
            left: left + window.scrollX,
            top: top + window.scrollY,
            minWidth: width,
            minHeight: height,
        };
    }
};
const Portal = forwardRef(({ className, children, container = document.body, contextualElementRef, tabIndex, onBlur, style = {}, }, ref) => {
    const childrenWrapperStyles = Object.assign(Object.assign({}, getChildrenWrapperStyles(contextualElementRef)), style);
    return ReactDOM.createPortal(React.createElement(StyledChildrenWrapper, { className: className, style: childrenWrapperStyles, tabIndex: tabIndex, onBlur: onBlur, ref: ref }, children), container);
});
export default Portal;
